import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.NODE_ENV === 'production' ? "https://inotecread.acventis.one" : 'https://inotecread.acventis.one';

const socket = io(URL);

export default socket;
